/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonLoginRequest
 */
export interface JsonLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof JsonLoginRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonLoginRequest
     */
    password?: string;
    /**
     * 
     * @type {boolean}
     * @memberof JsonLoginRequest
     */
    rememberMe?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JsonLoginRequest
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonLoginRequest
     */
    tokenType?: JsonLoginRequestTokenTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum JsonLoginRequestTokenTypeEnum {
    Remember = 'REMEMBER',
    Recover = 'RECOVER',
    Activate = 'ACTIVATE'
}

export function JsonLoginRequestFromJSON(json: any): JsonLoginRequest {
    return JsonLoginRequestFromJSONTyped(json, false);
}

export function JsonLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonLoginRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'rememberMe': !exists(json, 'rememberMe') ? undefined : json['rememberMe'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'tokenType': !exists(json, 'tokenType') ? undefined : json['tokenType'],
    };
}

export function JsonLoginRequestToJSON(value?: JsonLoginRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
        'rememberMe': value.rememberMe,
        'token': value.token,
        'tokenType': value.tokenType,
    };
}

